import { GlIcon, GlTooltipDirective } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import { formatTime } from '~/lib/utils/datetime_utility';
import CiIcon from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/ci_icon/ci_icon.vue?vue3';
import TimeAgoTooltip from '/builds/gitlab/gitlab-ee/app/assets/javascripts/vue_shared/components/time_ago_tooltip.vue?vue3';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import { sprintf, s__ } from '~/locale';
export default {
    name: 'StatusCell',
    iconSize: 12,
    i18n: {
        statusDescription: (id)=>sprintf(s__('Jobs|Status for job %{id}'), {
                id
            })
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    components: {
        CiIcon,
        GlIcon,
        TimeAgoTooltip
    },
    props: {
        job: {
            type: Object,
            required: true
        }
    },
    computed: {
        jobId () {
            const id = getIdFromGraphQLId(this.job.id);
            return `#${id}`;
        },
        statusDescriptionId () {
            return `ci-status-description-${this.jobId}`;
        },
        finishedTime () {
            return this.job?.finishedAt;
        },
        duration () {
            return this.job?.duration;
        },
        durationFormatted () {
            return formatTime(this.duration * 1000);
        }
    }
};
